/*
*******************************************************************************************
This Enum is sorted alphabetically. Please consider this when you are adding new event type
*******************************************************************************************
*/

export enum GtmSolutionEnum {
  MM_marketplace = 'mm_marketplace'
}
